export default "__VITE_ASSET__c2f446bf__"